module.exports = __webpack_public_path__ + "img/realboardTitle.dca927cc.png";